module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/montserrat-light-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/montserrat-light-webfont.woff
// module id = 343
// module chunks = 0